:root {
  --semantics-button-size-2xs: var(--primitives-values-value-24);
  --semantics-button-size-xs: var(--primitives-values-value-32);
  --semantics-button-size-sm: var(--primitives-values-value-40);
  --semantics-button-size-md: var(--primitives-values-value-44);
  --semantics-button-size-lg: var(--primitives-values-value-48);
  --semantics-button-size-xl: var(--primitives-values-value-56);
  --semantics-button-inner-shadow-3: var(--primitives-values-value-3);
  --semantics-button-inner-shadow-4: var(--primitives-values-value-4);
  --semantics-button-inner-shadow-6: var(--primitives-values-value-6);
  --semantics-radius-8: var(--primitives-values-value-8);
  --semantics-radius-10: var(--primitives-values-value-10);
  --semantics-radius-12: var(--primitives-values-value-12);
  --semantics-radius-14: var(--primitives-values-value-14);
  --semantics-radius-16: var(--primitives-values-value-16);
  --semantics-radius-18: var(--primitives-values-value-18);
  --semantics-radius-20: var(--primitives-values-value-20);
  --semantics-radius-22: var(--primitives-values-value-22);
  --semantics-radius-24: var(--primitives-values-value-24);
  --semantics-radius-26: var(--primitives-values-value-26);
  --semantics-radius-28: var(--primitives-values-value-28);
  --semantics-radius-32: var(--primitives-values-value-32);
  --semantics-radius-40: var(--primitives-values-value-40);
  --semantics-radius-999: var(--primitives-values-value-999);
  --semantics-icon-xs: var(--primitives-values-value-16);
  --semantics-icon-sm: var(--primitives-values-value-20);
  --semantics-icon-md: var(--primitives-values-value-24);
  --semantics-icon-lg: var(--primitives-values-value-32);
  --semantics-icon-xl: var(--primitives-values-value-40);
  --semantics-units-unit-0: var(--primitives-values-value-0);
  --semantics-units-unit-2: var(--primitives-values-value-2);
  --semantics-units-unit-4: var(--primitives-values-value-4);
  --semantics-units-unit-8: var(--primitives-values-value-8);
  --semantics-units-unit-12: var(--primitives-values-value-12);
  --semantics-units-unit-16: var(--primitives-values-value-16);
  --semantics-units-unit-20: var(--primitives-values-value-20);
  --semantics-units-unit-24: var(--primitives-values-value-24);
  --semantics-units-unit-32: var(--primitives-values-value-32);
  --semantics-units-unit-40: var(--primitives-values-value-40);
  --semantics-units-unit-44: var(--primitives-values-value-44);
  --semantics-units-unit-48: var(--primitives-values-value-48);
  --semantics-units-unit-52: var(--primitives-values-value-52);
  --semantics-units-unit-56: var(--primitives-values-value-56);
  --semantics-units-unit-64: var(--primitives-values-value-64);
  --semantics-units-unit-72: var(--primitives-values-value-72);
  --semantics-units-unit-80: var(--primitives-values-value-80);
  --semantics-units-unit-88: var(--primitives-values-value-88);
  --semantics-units-unit-96: var(--primitives-values-value-96);
  --semantics-units-unit-104: var(--primitives-values-value-104);
  --semantics-units-unit-112: var(--primitives-values-value-112);
  --semantics-units-unit-120: var(--primitives-values-value-120);
  --semantics-units-unit-128: var(--primitives-values-value-128);
  --semantics-units-unit-999: var(--primitives-values-value-999);
  --semantics-border-outline-xs: var(--primitives-values-value-1);
  --semantics-border-outline-sm: var(--primitives-values-value-1-5);
  --semantics-border-outline-md: var(--primitives-values-value-2);
  --semantics-border-outline-lg: var(--primitives-values-value-2-5);
  --semantics-border-outline-xl: var(--primitives-values-value-3);
  --semantics-typography-weight-400: var(--primitives-typography-weight-regular);
  --semantics-typography-weight-500: var(--primitives-typography-weight-medium);
  --semantics-typography-weight-600: var(--primitives-typography-weight-semibold);
  --semantics-typography-weight-700: var(--primitives-typography-weight-bold);
  --semantics-typography-family-heading: var(--primitives-typography-family-heading);
  --semantics-typography-family-body: var(--primitives-typography-family-body);
  --semantics-typography-family-caption: var(--primitives-typography-family-caption);
  --semantics-typography-line-height-heading-lg: var(--primitives-typography-line-height-heading-lg);
  --semantics-typography-line-height-heading-md: var(--primitives-typography-line-height-heading-md);
  --semantics-typography-line-height-heading-sm: var(--primitives-typography-line-height-heading-sm);
  --semantics-typography-line-height-heading-xs: var(--primitives-typography-line-height-heading-xs);
  --semantics-typography-line-height-heading-xxs: var(--primitives-typography-line-height-heading-xxs);
  --semantics-typography-line-height-heading-tiny: var(--primitives-typography-line-height-heading-xxxs);
  --semantics-typography-line-height-body-md: var(--primitives-typography-line-height-body-md);
  --semantics-typography-line-height-body-sm: var(--primitives-typography-line-height-body-sm);
  --semantics-typography-line-height-body-xs: var(--primitives-typography-line-height-body-xs);
  --semantics-typography-line-height-body-xxs: var(--primitives-typography-line-height-body-xxs);
  --semantics-typography-letter-spacing-heading: var(--primitives-typography-letter-spacing-heading);
  --semantics-typography-letter-spacing-body: var(--primitives-typography-letter-spacing-body);
  --semantics-typography-letter-spacing-caption: var(--primitives-typography-letter-spacing-caption);
  --semantics-typography-size-heading-lg: var(--primitives-typography-size-heading-lg);
  --semantics-typography-size-heading-md: var(--primitives-typography-size-heading-md);
  --semantics-typography-size-heading-sm: var(--primitives-typography-size-heading-sm);
  --semantics-typography-size-heading-xs: var(--primitives-typography-size-heading-xs);
  --semantics-typography-size-heading-xxs: var(--primitives-typography-size-heading-xxs);
  --semantics-typography-size-heading-tiny: var(--primitives-typography-size-heading-tiny);
  --semantics-typography-size-body-md: var(--primitives-typography-size-body-md);
  --semantics-typography-size-body-sm: var(--primitives-typography-size-body-sm);
  --semantics-typography-size-body-xs: var(--primitives-typography-size-body-xs);
  --semantics-typography-size-body-xxs: var(--primitives-typography-size-body-xxs);
}
